

export const calculateCustomerFinances = (customer: any) => {
    // 1. Calculate Total Project Value (Billable)
    const projectValue = customer.projects?.reduce((total: number, project: any) => {
        if (project.billingMethod === 'Fixed Cost') {
            return total + (project.hourlyRate || 0);
        }

        const projectTotalHours = project.timesheets?.reduce((pTotal: number, t: any) => {
            const [h, m] = t.timeSpent.split(':').map(Number);
            return pTotal + (h + m / 60);
        }, 0) || 0;
        return total + (projectTotalHours * (project.hourlyRate || 0));
    }, 0) || 0;

    // 2. Calculate Total Expenses (Billable)
    const totalExpenses = customer.expenses?.reduce((sum: number, exp: any) => sum + (exp.amount || 0), 0) || 0;

    // 3. Calculate Global Payments
    const totalPayments = customer.payments?.reduce((sum: number, pay: any) => sum + (pay.amount || 0), 0) || 0;

    // Total Billable = Project Value + Expenses
    const totalBillable = projectValue + totalExpenses;

    // Outstanding = Total Billable - Total Payments
    const outstanding = totalBillable - totalPayments;

    return {
        totalBillable,
        totalPaid: totalPayments,
        outstanding
    };
};

// Deprecated: keeping for backward compatibility if needed, but Customers.tsx will be updated.
export const calculateReceivables = (customer: any): number => {
    return calculateCustomerFinances(customer).outstanding;
};
